import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "FilePersiapanPensiun";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const pensiunCreate = "Kepegawaian/FilePersiapanPensiun/create/";
export const pensiunList = "Kepegawaian/FilePersiapanPensiun/list/";
export const pensiunListparicipant =
  "Kepegawaian/FilePersiapanPensiun/list_participant/";
export const pensiunListMonitoring =
  "Kepegawaian/FilePersiapanPensiun/list_monitoring/";
export const pensiunDetail = "Kepegawaian/FilePersiapanPensiun/detail/";
export const pensiunUpdate = "Kepegawaian/FilePersiapanPensiun/update/";
export const pensiunInactive = "Kepegawaian/FilePersiapanPensiun/inactive/";
export const pensiunActive = "Kepegawaian/FilePersiapanPensiun/active/";
export const masterEmployee = "Kepegawaian/FilePersiapanPensiun/list_employee/";
export const masterType = "Kepegawaian/FilePersiapanPensiun/list_type/";
export const exportExcel = "Kepegawaian/FilePersiapanPensiun/exportExcel/";
export const pensiunSubmit = "Kepegawaian/FilePersiapanPensiun/submit/";
export const pensiunSubmission = "Kepegawaian/FilePersiapanPensiun/submission/";
export const loadEmployee = "Kepegawaian/FilePersiapanPensiun/load_employee/";
export const syaratDokumen = "Kepegawaian/FilePersiapanPensiun/list_syarat/";
export const listTahun = "Kepegawaian/FilePersiapanPensiun/load_year/";
export const detailSubmission =
  "Kepegawaian/FilePersiapanPensiun/detail_submission/";
export const pensiunApprove = "Kepegawaian/FilePersiapanPensiun/approve/";
export const pensiunDetailApprovePeriod =
  "Kepegawaian/FilePersiapanPensiun/approveperioddetail/";
export const pensiunApprovePeriod =
  "Kepegawaian/FilePersiapanPensiun/approveperiodsubmit/";
export const pensiunDocuments =
  "Kepegawaian/FilePersiapanPensiun/load_syarat_pensiun/";
export const pensiunExport = "Kepegawaian/FilePersiapanPensiun/export_excel/";

export const masterBank = "Master/List/bank/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
